export default __webpack_public_path__ + "static/media/numOfCars.802713a7.svg";